import path from 'path';

/**
 * Arbre affiché par la barre latérale, construit à partir des routes DÉJÀ
 * filtrées par les droits (store `permission`). Purement présentationnel : il
 * n'ajoute aucune route, ne démasque aucune page et ne touche pas au routeur.
 *
 * Un groupe (`meta.is_group`) déroule les pages de ses modules sur un seul
 * niveau — « Facturation > Prélèvements », et non « Facturation > Prélèvements
 * auto. > Liste complète ». Chaque page garde l'URL complète de son module.
 * Un groupe réduit à une page par les droits devient une entrée simple ; un
 * groupe sans page disparaît.
 */
export function menuTree(routes = []) {
  return routes.flatMap(route => {
    if (!route.meta?.is_group) return [route];

    const pages = (route.children || []).flatMap(pagesOf);
    if (!pages.length) return [];

    const meta = { ...route.meta };
    delete meta.is_group;
    return [{ path: route.path, meta, alwaysShow: pages.length > 1, children: pages }];
  });
}

function pagesOf(module) {
  if (module.hidden) return [];
  return (module.children || [])
    .filter(page => !page.hidden)
    .map(page => ({
      ...page,
      path: path.resolve(module.path, page.path),
      meta: { ...page.meta, icon: page.meta?.icon || module.meta?.icon },
    }));
}
